export default __webpack_public_path__ + "dc6e03ae8d692f3c7c76135bb87902af.png";